import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  shoppingTab: null,
};

const shoppingSlice = createSlice({
  name: 'shopping',
  initialState,
  reducers: {
    setShoppingTab: (state, action) => {
      state.shoppingTab = action.payload;
    },
  },
});

export const { setShoppingTab } = shoppingSlice.actions;

export default shoppingSlice.reducer;
